const header = $("header.header");
const body = $("body");
const menuBtn = $(".js-header-menu-button");
const menu = $(".js-header-menu");
const menuOverlay = $(".js-menu-overlay");
const dropdown = $(".dropdown");
let _prevScroll = window.scrollY;

function toggleMenu() {
  if (menu.hasClass("js-active")) {
    menu.removeClass("js-active");
    menuOverlay.fadeOut(300);
    body.removeClass("is-menu-open");
  } else {
    menu.addClass("js-active");
    menuOverlay.fadeIn(300);
    body.addClass("is-menu-open");
  }
}

menuBtn.on("click", toggleMenu);
menuOverlay.on("click", toggleMenu);

dropdown.each(function (_, element) {
  const $item = $(element).children(".dropdown__current");
  if (!body.hasClass("touch-on") && isLanguageDrop(element)) return;
  $item.on("click", function (e) {
    e.stopPropagation();
    const $this = $(this);
    const $parent = $this.parent();
    const $secondParent = $parent.parent();
    const $list = $parent.children(".dropdown__list:first");
    if ($parent.hasClass("js-active")) {
      $parent.removeClass("js-active");
      $list.slideUp(300);
    } else {
      $secondParent.siblings().each(function (_, el) {
        const thatDrop = $(el).children(".dropdown");
        thatDrop.removeClass("js-active");
        thatDrop.find(".dropdown__list").slideUp(300);
      });
      $parent.addClass("js-active");
      $list.slideDown(300);
    }
  });
});

function isLanguageDrop(el) {
  return $(el).parent().hasClass("header__language");
}

function listenScroll() {
  const headerHeight = header.outerHeight();
  const prevScroll = _prevScroll;
  const currentScroll = window.scrollY;
  if (currentScroll <= headerHeight) return;
  let isVisible = true;
  if (currentScroll <= 0) {
    isVisible = true;
  } else if (currentScroll > prevScroll) {
    isVisible = false;
  } else if (currentScroll < prevScroll) {
    isVisible = true;
  } else {
    return;
  }
  _prevScroll = currentScroll;
  if (isVisible) {
    header.removeClass("header--is-hidden");
  } else {
    header.addClass("header--is-hidden");
  }
}

$(window).on("scroll", listenScroll);

$("body").on("click", function (e) {
  const container = $(".header__language");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    const activeDropdown = container.find(".dropdown.js-active");
    if (activeDropdown) {
      activeDropdown.find(".dropdown__current").click();
    }
  }
});
